import { FormikProps } from 'formik';
import { TextFieldNoLabel } from '../../../components/index';
import { SignInFormProps } from '../types/sign-up-form-types';

interface PasswordInputProps {

  formik: FormikProps<SignInFormProps>;

  disabled: boolean;

}

const PasswordInput = ({formik} :any) => {
  const inputProps = {
    value: formik.values.password,
    onChange: formik.handleChange,
    error: formik.touched.password && Boolean(formik.errors.password),
    helperText: formik.touched.password && formik.errors.password,
  }
  return (
    <TextFieldNoLabel textDesc='Password' name="password" inputProps={inputProps} type='password' placeholder='Enter your password' isPassword />
  )
}

export default PasswordInput;